<template>
    <div style="background:white; height:100%">   
        <section v-loading="loading"></section>  
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;padding-top:3px; border-bottom:2px solid #389;">   
            <div style="width:1300px;display:flex; ">             
                <div style="font-size:12px;line-height:30px;  width:55px;margin-left:5px">查询字段</div>
                <el-select v-model="selparam"  placeholder="请选择列名" filterable  size="small" style="width:120px;margin-left:2px; ">
                    <span v-for="item in payCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:280px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input>
 
                <span style="color:#389;margin-left:10px; font-size:12px;width:30px">状态</span>
                <el-select v-model="stfg_"  size="small" @change="stfgChange" style="width:90px;margin-bottom:3px;margin-left:2px; ">
                    <el-option label="所有订单" value="ALL" ></el-option>
                    <el-option label="已对账" value="Y" ></el-option> 
                    <el-option label="未对账" value="N" ></el-option> 
                </el-select> 
                <el-button type="danger" @click="editRec" icon="iconfont icon-fapiaoguanli" size="mini" style="width:70px; margin-left:10px;height:32px">对账</el-button>
 
                <el-button type="primary"   icon="iconfont icon-daochu" @click="expExcel" size="mini" style="margin-left:15px;height:30px;margin-top:1px">导出当前页面</el-button>
            </div>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border"
            :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
            header-cell-class-name="clearPadding"
            style="overflow:auto;margin-top:1px;"
            size="small"
            :height="tabHeight" 
            :row-key="getRowKey"  
            ref="tabref" 
            @row-click="rowClick"
            v-loading="v_loading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(100, 100, 100, 0.8)"
            show-summary
            :summary-method="getAmt"
            highlight-current-row>
            <el-table-column label="序号" type="index" width="50" fixed>
                <el-table-column label="序号" type="index" width="50" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in payCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope"><span style="color:red" v-if="item.notnull=='Y'"> </span>
                        {{scope.row}}
                        <el-select v-if="item.key=='FCHK'" @change="qryTabData" v-model="v_inputrow[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="是" value="Y"  ></el-option>
                            <el-option label="否" value="N"  ></el-option>
                        </el-select>
                        <el-checkbox v-else-if="item.key=='SEL'" @change="selChg" size="mini"  v-model="v_select" true-label="Y" false-label="N"></el-checkbox> 
                        <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_inputrow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_inputrow[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_inputrow[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>                
                    <template  slot-scope="scope" >
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-link v-else-if="item.key=='FINVNO'" :underline="false" @click="repShow2(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']=='Y'" size="mini" type="success" effect="dark"  >是</el-tag>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']!=='Y'" size="mini" type="info" effect="dark">否</el-tag> 
                        <el-checkbox v-else-if="item.edcss=='checkbox'" disabled v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-checkbox :disabled="scope.row['FCHK']=='Y'" v-else-if="item.key=='SEL'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-link v-else-if="item.key=='FILEPATH'" :underline="false" > 
                            <div v-if="scope.row[item.key] && scope.row[item.key].lastIndexOf('.pdf')>-1 ">
                                <div @click="imgPreview(scope.row[item.key])" slot="error"><i class="iconfont icon-pdf"></i></div>
                            </div>
                            <el-image v-else style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <el-link v-else-if="item.key=='OKAMT'" :underline="false" @click="okShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid green;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column>
            </el-table-column>  
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="70">
                <template slot-scope="scope">
                    <i class="iconfont icon-icon-chaolianjie" style="color:#409EFF;font-size:14px;margin-right:2px;"></i>
                    <el-link :disabled="scope.row['FCHK']!=='Y'" @click="attBtn(scope.row,scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">附件</span></el-link> 
                </template>
            </el-table-column>                      
        </el-table>  
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="one-div"><span class="oneRow"> 明细资料 </span></div>
        <el-table  :data="dtlData" 
            border                
            class="custom-table-border"            
            size="small"
            ref="refdtl"
            show-summary
            :summary-method="getSummary"
            style="margin-top:-8px"
            :cell-style="{padding:'2px'}"
            :height="265" 
            highlight-current-row> 
            <el-table-column label="序号" type="index" width="60" ></el-table-column>
            <el-table-column  v-for="(item,index ) in perCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
            </el-table-column>               
        </el-table>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" width="500px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;display:flex">
                <span style="padding-left:5px;font-size:12px;font-weight:600"> 基本信息 </span>
                <el-link @click="viewData" :underline="false" style="margin-left:15px;border-bottom:1px solid red;color:#389">速珀开票资料</el-link>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">单据编码</div>
                <el-input size="medium" disabled v-model="v_idno" style="width:100%;font-size:12px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">单据金额</div>
                <el-input size="medium" disabled v-model="v_amt" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">单据条数</div>
                <el-input size="medium" disabled v-model="v_cnt" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:red">发票号码</div>
                <el-input size="medium" v-model="v_finvno" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:red">发票金额</div>
                <el-input-number size="medium" v-model="v_invamt" style="width:100%;font-size:14px"> </el-input-number>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px">对账日期</div>
                <el-input disabled size="medium" v-model="v_dttm" style="width:100%;font-size:14px">  </el-input>
            </div>
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;margin-top:15px">
                <span style="padding-left:5px;font-size:12px;font-weight:600"> 上传发票附件 </span>
            </div> 
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successImgFile"
                :with-credentials="true"                            
                :format="['jpg','jpeg','png','pdf' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                v-if="fileUrl.length<2"
                style="display: inline-block;width:200px; ">                           
                <div style="padding: 1px 0;width:200px;height:200px;">
                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                </div>                                                       
            </Upload> 
            <div  v-if="fileUrl.length>2" >
   
                <div v-if="fileUrl.lastIndexOf('.pdf')>-1" style="width:200px;height:200px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="fileUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else-if="fileUrl.length>2"  :preview-src-list="[fileUrl]" fit="fill"  style="width:200px;height:200px;margin-right:30px;" :src="fileUrl"></el-image>
                <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                    <el-link  :underline="false" @click="imgDel(fileUrl)"><Icon type="md-close" /> 删除</el-link>
                    <el-link v-if="fileUrl.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(fileUrl)"><Icon type="ios-search" /> 预览</el-link>
                </div>
          
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button type="primary" @click="saveRec" size="small" style="margin-left:30px" icon="iconfont icon-chenggong"> 确认</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <div style="height:600px;overflow-y:auto">
                <el-image fit="scale-down"  style=" margin:5px auto; height:500px;width:100% " :preview-src-list="srcList" :src="listurl"></el-image>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="editWin" width="520px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">对账确认</span>
            </div> 
 
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px">
                <span style="padding-left:5px;font-size:14px;font-weight:600;color:red"> 基本信息（ 提示：已对账 “ 未勾选 ” 时，确认后 会自动更新 发票号码为空 ） </span>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">单据编码</div>
                <el-input size="medium" disabled v-model="v_row['IDNO']" style="width:100%;font-size:12px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">单据金额</div>
                <el-input size="medium" disabled v-model="v_row['AMT']" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:#409eff">已对账</div>
                <el-checkbox size="medium" true-label="Y" false-label="N" border v-model="v_row['FCHK']" style="width:100%;font-size:14px"> </el-checkbox>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">发票号码</div>
                <el-input size="medium"  disabled v-model="v_row['FINVNO']" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">发票金额</div>
                <el-input-number disabled size="medium" v-model="v_row['INVAMT']" style="width:100%;font-size:14px"> </el-input-number>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px">对账日期</div>
                <el-input disabled size="medium" v-model="v_row['FINDTTM']" style="width:100%;font-size:14px">  </el-input>
            </div>
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;margin-top:15px">
                <span style="padding-left:5px;font-size:12px;font-weight:600"> 发票附件 </span>
            </div> 
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successImgFile"
                :with-credentials="true"                            
                :format="['jpg','jpeg','png','pdf' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                v-if="fileUrl.length<2"
                style="display: inline-block;width:200px; ">                           
                <div style="padding: 1px 0;width:200px;height:200px;">
                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                </div>                                                       
            </Upload> 
            <div  v-if="fileUrl.length>2" >
                <div v-if="fileUrl.lastIndexOf('.pdf')>-1" style="width:200px;height:200px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="fileUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else-if="fileUrl.length>2"  :preview-src-list="[fileUrl]" fit="fill"  style="width:200px;height:200px;margin-right:30px;" :src="fileUrl"></el-image>
                <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                    <el-link  :underline="false" @click="imgDel(fileUrl)"><Icon type="md-close" /> 删除</el-link>
                    <el-link v-if="fileUrl.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(fileUrl)"><Icon type="ios-search" /> 预览</el-link>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                <span style="float:right">
                    <el-button type="info" @click="editWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button type="primary" @click="attSave" size="small" style="margin-left:30px" icon="iconfont icon-chenggong"> 确认</el-button>
                </span>
            </div>
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate, getDate2 } from '../../api/Select' 
//局部注册
export default {
    name:"po_paychk",
    data () {
        return {
            repWin:false,
            repUrl:'',
            supArr:[],
            addWin:false,
            payCol:[],
            editWin:false,
            v_filePath:'',    
            dtlRow:{},
            operFlag:false,
            saveFlag:true,
            listurl:'',
            promptWin:false,
            prompt:'',
            showViewer:false,
            v_idno:'',
            v_amt:0,
            v_cnt:0,
            mainRow:{},
            input_hold:'请输入查询的值',
            v_data:[],
            listIndex:'-1',
            active:'', //二级菜单选中标志
            stfg_:'N',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
            perCol:[],
            operArr:[],
            oper:'like',
            srcList:[],
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            v_select:'N',
            delArr:[],
            empArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            loading:false,
            v_loading:false,
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            stfgArr:[],
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            v_index:'',   
            v_idseq:'',  
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            fileUrl:'N',
            fileName:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            v_inputrow:{},
            v_row:{},
            v_finvno:'',
            v_invamt:'',
            v_dttm:'',
            v_oth:'N',
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','397193','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
          
            let row =res.result[0]
            this.v_oth =row['ISOTH']
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //作废
                this.cancelBool=true
            }
            this.qryTabData()
 
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
 
        //供应商
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
 
        
 
    },
    computed: {
 
        tabHeight: function() {
            return (window.innerHeight - 455) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        selChg(){
            this.tabData.forEach(item=>{
                item.SEL =this.v_select
            })
        },
        rowShow(){
            Object.keys(this.v_inputrow).forEach(item=>{
                this.v_inputrow[item] =''
            })
            this.qryTabData()
        } ,
        viewData(){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: 'http://139.9.191.205:8088/assets/authorize/2025-01-11-14-59-19-DATA.pdf'},
            });
            window.open(routeUrl.href, '_blank');
        },
        attBtn(row,index){
            this.v_row =JSON.parse(JSON.stringify(row))
            if (row['FILEPATH']){
                this.fileUrl =row['FILEPATH']
                this.v_filePath=row['NASPATH']
            }        
            this.editWin =true
        },
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(filePath){
            if (filePath)
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.fileUrl='N' 
                if (this.v_filePath.indexOf('https://')>-1 && this.v_filePath){
                    this.$axios({
                        method: 'post',
                        url: '/xuper_oss/ftpDelete',
                        data: {p_path:'/volume1'+this.v_filePath},
                    }).then(res=>{ 
                        this.v_filePath=''
                    })
                }     
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择pdf或图片格式'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            this.v_filePath='/web/web_images/material/'+res.result                
            let v_filename=this.$store.state.nasUrl+res.result
            this.fileUrl =v_filename                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        repShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'fin_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        repShow2(row){
            if (row['FINVNO']!=='无'){
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+ 'inv_stkchk.cpt'+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO'] +'&p_invno='+row['FINVNO'] 
            }
        },
        okShow(row){
            let v_idseq=row['BANK_IDSEQ'].split(',') 
            this.srcList=[]
            v_idseq.forEach(item=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'IDSEQ',p_value:item, p_table:'V_MAT_IMG'},
                }).then(res=>{ 
                    this.srcList.push(res.result[0]['XUPER_PATH'])
                    this.listurl=res.result[0]['XUPER_PATH']
                    this.showViewer=true
                })
            })
           // this.showViewer=true
             //   this.listurl=path
              //  this.srcList=[path]
        },
        //图片预览
        imgPreview(path){
            if (path &&path.toLowerCase().lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listurl=path
                this.srcList=[path]
            }
        },
 
        //导出
        expExcel(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'397193',p_lstseq:'2062',p_json:JSON.stringify(this.allList),p_action:'对账单'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '对账单_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        //表行点击事件
        rowClick(row){
            this.getDtlData(row.IDSEQ,row['REFTY'])
  
        },
        // 附件保存
        attSave(){
            this.$confirm('此操作将会影响与此发票号码相同的所有单据，要继续吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{    
                let v_path =this.fileUrl=='N'?'':this.fileUrl ,v_invno =this.v_row['FINVNO'],v_dttm=this.v_row['FINDTTM']
                if (this.v_row['FCHK']!=='Y'){
                    v_invno =''
                    v_dttm=''
                }
                let v_cond=' set  filepath=\''+v_path+'\',fchk=\''+this.v_row['FCHK']+'\',FINVNO=\''+v_invno+'\',FINDTTM=\''+v_dttm+'\',naspath=\''+this.v_filePath+'\''
                //let v_cond=' set  filepath=\''+v_path+'\',  FINVNO=\''+v_invno+'\' '
                let v_table='ic_stk'
                if (this.v_row['REFTY']=='POFEE'){
                    v_table ='PO_ORD'
                }
                if (this.v_row['FINVNO'] && this.v_row['FINVNO']!=='无' && this.v_row['FINVNO']!=='已开'){
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'FINVNO',p_value:this.v_row['FINVNO'], p_table:v_table,p_cond:v_cond},
                    }).then(res=>{ 
                        if (res.code!='200'){
                            this.promptWin =true
                            this.prompt =res.result
                        }else{
                            this.editWin =false
                        }
                    })
                }else{
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'IDNO',p_value:this.v_row['IDNO'], p_table:v_table,p_cond:v_cond},
                    }).then(res=>{ 
                        if (res.code!='200'){
                            this.promptWin =true
                            this.prompt =res.result
                        }else{
                            this.editWin =false
                        }
                    })
                }
            }).catch(err=>{})
        },
        //对账确定
        saveRec(){
            console.log(JSON.stringify(this.v_data.map(item=>item.IDSEQ).join(',')),'...')
            if (!this.v_finvno){
                this.promptWin =true
                this.prompt ='发票号码不能为空'
            }else if (!this.v_invamt){
                this.promptWin =true
                this.prompt ='发票金额不能为空'
            }else if (Math.floor(Number(this.v_invamt) ) !==Math.floor(Number(this.v_amt) )){  //向下取整 
                this.promptWin =true
                this.prompt ='发票金额与单据金额不相等'
            }
            else if (this.fileUrl=='N' && (this.v_finvno !=='无' && this.v_finvno !=='已开' )){
                this.promptWin =true
                this.prompt ='请上传发票'
            }
            else{
                let v_path =this.fileUrl=='N'?'':this.fileUrl
                let v_cond=' set FLAG=\'ADMIN\',FINVNO=\''+this.v_finvno+'\',FCHK=\'Y\',findttm=\''+getDate('full')+'\',invamt='+this.v_invamt+',filepath=\''+v_path+'\',naspath=\''+this.v_filePath+'\''
                //循环 更新
                let v_k=0
                this.v_data.forEach(item =>{
                    let v_table='ic_stk'
                    if (item['REFTY']=='POFEE'){
                        v_table ='PO_ORD'
                    }
                    v_k =v_k+1
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:item['IDSEQ'], p_table:v_table,p_cond:v_cond},
                    }).then(res=>{ 
                        if (res.code!='200'){
                            this.promptWin =true
                            this.prompt =res.result
                        }
                    })
                })
                if (v_k ==this.v_data.length){
                    this.addWin =false
                    this.qryTabData()
                }
            }
        },
        //订单明细
        getOrdList(cond){
            let v_cond = ' and idty in (\'POIN\',\'PRDIN\',\'PORTN\')'
            if ( this.v_oth=='Y' ){
                v_cond = ' and supno in (select idno from V_bs_sup where PHONENO=\''+this.v_username+'\')'
            }
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value:this.v_corpid, p_cond:v_cond +cond+ ' and stfg=\'Y\' order by '+this.selparam+' desc',p_table:'V_IC_STKCHK'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                    })
                    this.initPage()
                    this.v_loading =false
                    if (this.tabData.length>0){
                        this.$refs.tabref.setCurrentRow(this.tabData[0])
                        this.getDtlData(this.tabData[0]['IDSEQ'],this.tabData[0]['REFTY'])
                    }else{
                        this.dtlData=[]
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.v_loading =false
                }
                
            }) 
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index==1){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='AMT'){
                    let v_sum=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ) 
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getAmt(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===1){
                    sums[index]='合计'
                    return
                }
                const values =this.allData.map(item=>Number(item[column.property]));
                if( column.property==='AMT'||column.property==='OKAMT'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ) 
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        //查询明细数据
        getDtlData(idseq,type){
            this.dtlData=[]
            let v_table='V_STKDTL'
            if (type=='POFEE'){ //采购 费用 MOQ ,运费等
                v_table ='V_PO_ORDFEE'
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:v_table},
            }).then(res=>{ 
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                }) 
            })
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
    
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            
            }
 
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //对账确认
        editRec(){
            this.v_data=[]
            this.tabData.forEach(item=>{
                if (item['SEL']=='Y'){
                    this.v_data.push(JSON.parse(JSON.stringify(item)))
                }
            })
            if (this.v_data.length ==0){
                this.promptWin =true
                this.prompt ='请选择需要对账的单据'
            }else{
                this.v_dttm =getDate('full')
                this.v_cnt =this.v_data.length
                let amt_ =0, idno_=''
                this.v_data.forEach(item=>{
                    if (idno_){
                        idno_ =idno_+','+item['IDNO']
                    }else{
                        idno_ =item['IDNO']
                    }
                    amt_ =Number(amt_)+Number(item['AMT'])
                })
                this.v_idno =idno_  //单据编码
                this.v_amt =amt_.toFixed(2)   //应付金额
                this.v_finvno =''
                this.v_invamt =''
                this.fileUrl='N'
                this.v_filePath=''
                this.addWin=true    
            }
 
                           
        },
 
        getRowKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_inputrow).forEach(item=>{
                if (this.v_inputrow[item] ){
                    this.payCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_inputrow[item] 
                    }else{
                        v_cond =v_cond +' and '+item+'  like \'%'+ (this.v_inputrow[item]).trim()+'%\''
                    }

                }
            })           
            if (this.stfg_=='ALL'){
                this.getOrdList( cond_+v_cond)
            }else {
                this.getOrdList( ' and fchk=\''+this.stfg_+'\''+ cond_+v_cond)
            }
        },
 
        //状态查询
        stfgChange(){
            this.getOrdList( ' and icdttm>=\''+getDate2(180)+'\' ' )
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            // getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2059','','',' order by sortby,lstseq').then((res) => {
            //     for (let k=0; k<res.result.length; k++){
            //         vm.tabArr.push({ //向数组的开头 添加序列号
            //             title: res.result[k].title,
            //             key: res.result[k].key,
            //             align: res.result[k].align,
            //             width: res.result[k].width,
            //             thide:res.result[k].THIDE,
            //             fhide:res.result[k].FHIDE,
            //             edcss:res.result[k].EDCSS,
            //             disabled:res.result[k].DISABLED,
            //             dotnum:res.result[k].DOTNUM,
            //         })
            //     }
            // })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2060','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.perCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2062','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.payCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 98%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .item-one{
        width: 96%;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 